module.exports = __webpack_public_path__ + "img/trainer-snip5.7c0b6aea.jpg";